import React from "react";
import { Skeleton } from "@/ui/Skeleton/Skeleton";
import cls from "./styles.module.scss";

// повторяет геометрию карточки реферала, чтобы после загрузки ничего не прыгало
export const ReferralDetailsSkeleton = () => (
  <>
    <div className={cls.card}>
      <div>
        <Skeleton height={20} width={160} radius={6} />
        <Skeleton height={13} width={100} style={{ marginTop: 8 }} />
      </div>

      <div className={cls.chips}>
        <Skeleton height={24} width="86px" radius={100} />
        <Skeleton height={24} width="110px" radius={100} />
      </div>

      <div>
        <div className={cls.ordersHead}>
          <Skeleton height={15} width={100} />
          <Skeleton height={13} width={90} />
        </div>
        <Skeleton height={6} radius={100} />
      </div>

      <div className={cls.list}>
        {[60, 45, 55, 50, 58, 48, 40, 62].map((width) => (
          <div key={width} className={cls.row}>
            <Skeleton height={13} width={width} />
            <Skeleton height={13} width="70px" />
          </div>
        ))}
      </div>
    </div>

    <div className={cls.actions}>
      <Skeleton height={52} radius={14} />
    </div>
  </>
);
